import { useQuery } from "@tanstack/react-query";
import apiClient from "lib/api-client";

const useGatiClients = () => {
  return useQuery({
    queryKey: ["gatiClients"],
    queryFn: async () => {
      const response = await apiClient.get("/api/v4/gati_client/getGatiClientsNamesDetails");
      if (response.data?.status === 200 && Array.isArray(response.data.clientData)) {
        return response.data.clientData.map((item) => ({ _id: item._id, clientName: item.clientName, partyNo: item.partyNo, partyCode: item.partyCode, firmEmail: item.firmEmail, otherFirmEmail: item.otherFirmEmail, otherWhatsAppNo: item.otherWhatsAppNo, whatsAppNo: item.whatsAppNo }));
      } else {
        throw new Error("Invalid response");
      }
    },
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });
};

export default useGatiClients;
